export const USER_REQUEST = "USER_REQUEST";
export const USER_UPDATE = "USER_UPDATE";
export const USER_UPDATED = "USER_UPDATED";
export const USER_DELETE = "USER_DELETE";
export const USER_CREATE = "USER_CREATE";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_ERROR = "USER_ERROR";
export const USER_LOADED = "USER_LOADED";
